import axios from "axios";

export default class integrityCompliance {
  constructor() {
    this.API_LINK = `${process.env.VUE_APP_API_LINK}/integrity-and-compliance`;
  }

  async getHome () {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/home`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateHome (params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/home`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCategories() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/categories`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCategory(categoryId) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/categories/${categoryId}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getSubcategory(subcategoryId) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/subcategories/${subcategoryId}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateCategory(categoryId, params) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/categories/${categoryId}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateSubcategory(subcategoryId, params) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/subcategories/${subcategoryId}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createDocument (params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/documents`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateDocument (documentId, params) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/documents/${documentId}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getYearsAndSemestersBySubcategory (subcategoryId) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/years-semesters/${subcategoryId}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDocumentsBySubcategoryAndYear(subcategoryId, year, semesterIndicator) {
    try {
      const semester = semesterIndicator ? semesterIndicator : ''
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/documents/by-subcategory/${subcategoryId}/${year}/${semester}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
